import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";

const Home = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
  {/* Sidebar */}
  <Sidebar user={user} setUser={setUser} />

  {/* Main Content */}
  <div style={{ flex: 1, padding: "20px" }}>
    
    {/* Heading + Logo */}
    <div
  style={{
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "20px",
  }}
>
  {/* LOGO */}
  <img
    src="/logo2.jpg"
    alt="Logo"
    style={{
      width: "300px",
      height: "250px",
      objectFit: "contain",
    }}
  />

  {/* TEXT - center inside remaining space */}
  <div
    style={{
      flex: 1,                     // take full width
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",    // vertical center
      alignItems: "center",        // horizontal center
    }}
  >
    <h1 style={{ color: "#ff0000ff", margin: 0, fontSize: "50px" }}>
      SRI SIDHI VINAYAKAA
    </h1>

    <h1 style={{ color: "#490dedff", margin: 0, fontSize: "50px" }}>
      DEVELOPERS
    </h1>
    <h3 style={{ textAlign: "center", color: "#ff0000ff", margin:0, fontSize: "30px" }}>
      Greatway for a better future
    </h3>
    <h4 style={{ textAlign: "center", color: "#1e6c28ff", margin:0, fontSize: "20px" }}>
          మంచి భవిష్యత్తు కోసం గొప్ప మార్గం
    </h4>
  </div>
  <img
    src="/logo.jpg"
    alt="Logo"
    style={{
      width: "300px",
      height: "250px",
      objectFit: "contain",
    }}
  />
</div>

    
    {/* Images Section */}
    <div
      style={{
        marginTop: "30px",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        gap: "20px",
        justifyItems: "center",
        alignItems: "center",
      }}
    >
      <img src="/image.png" alt="Gallery 1" style={styles.image} />
    </div>

  </div>
</div>
  );
}

const styles = {
  container: {
      display: "flex",
      justifyContent: "center", // centers horizontally
      alignItems: "center",     // centers vertically
      height: "100vh",          // full viewport height
    },
  image: {
  width: "100%",
  height: "100vh",        // full viewport height
  objectFit: "cover",     // crop image to fit
  borderRadius: "0px",   // no rounding, so it covers edges
  boxShadow: "none",      // remove shadow for fullscreen
},
};

export default Home;
